import { render, staticRenderFns } from "./sendquotation.vue?vue&type=template&id=3265c189"
import script from "./sendquotation.vue?vue&type=script&lang=js"
export * from "./sendquotation.vue?vue&type=script&lang=js"
import style0 from "./sendquotation.vue?vue&type=style&index=0&id=3265c189&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports